module.exports = __webpack_public_path__ + "img/captchaModalEN.3e1c5a21.png";